import { FC, useCallback } from 'react';

import { Button } from '@/Components/Button';
import { ExclamationSvg } from '@/Components/Icons/ExclamationSvg';
import { FlickAnimation } from '@/Components/FlickAnimation';
import { ModalView } from '@/Components/ModalView';
import { AppModalProps } from '@/types/modal.type';
import { useInteractiveCallback } from '@/hook/useInteractiveCallback';
import { FruitBlueberrySvg } from '@/Components/Icons/FruitBlueberrySvg';

type DeleteReelPublishedModalProps = AppModalProps<{
    reelName: string;
    onReview: () => void;
}>;

export const DeleteReelPublishedModal: FC<DeleteReelPublishedModalProps> = ({
    payload,
    onClose,
}) => {
    const onReview = useInteractiveCallback(() => {
        onClose();

        payload.onReview();
    });

    return (
        <ModalView
            maxWidth="sm"
            onClose={onClose}
            contentContainerClassName="py-6 px-8 text-brand-ocean flex flex-col justify-center items-center">
            <div className="relative min-w-60 h-24 flex items-center justify-center">
                <FlickAnimation className="absolute z-10 bottom-5 left-11" />
                <div className="absolute bottom-3 right-16">
                    <FruitBlueberrySvg bgFill="white" className="w-14 h-14" />
                </div>
            </div>
            <p className="w-full text-heading-five font-bold text-brand-ocean mb-2 mt-2">
                Video reel can’t be deleted just yet...
            </p>
            <div className="w-full text-body-text-15 text-left text-brand-ocean mb-4">
                Remove video "{payload.reelName}" from all published Flows
                before deleting it.
            </div>
            <div className="mt-2 w-full flex flex-col items-center justify-center gap-2">
                <Button
                    className="w-full h-9"
                    variant="primary"
                    onClick={onReview}>
                    Review Published Flows
                </Button>
                <Button
                    className="w-full h-9"
                    variant="default"
                    onClick={onClose}>
                    Cancel
                </Button>
            </div>
        </ModalView>
    );
};
